import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { updatePharmacyListTitle } from '../../actions/metaActions';

//TODO import store and use dispatch directly
@connect((store) => {
    return { };
})
class Over72Hours extends React.Component {

    goToElla() {
        this.props.history.push('/ella');
    }

    goToBirthControl() {
        this.props.history.push('/birthcontrol');
    }

    goToPregnancyList() {
        this.props.dispatch(updatePharmacyListTitle('Buy a pregnancy test'));
        // this.props.history.push('/pharmacylist');
        this.props.history.push('/pregnancytest');
    }
    
    render() {
        return (
            <div>
                <h1 className="ec__font__title text-center">It looks like you're outside the 72 hours</h1>
                <p className="ec__font__body text-center">We have a few suggestions:</p>
                
                <div className="card-container">

                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Ella
                            </p>
                            <p className="card__text">
                                Ella is effective up to 5 days, but you'll need a prescription.
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToElla.bind(this)}>Find Ella</a>
                        </div>
                    </div>

                    {/* <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Meet with a doctor
                            </p>
                            <p className="card__text">
                                Meet with a doctor & get a better birth control method that works for YOU.
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToBirthControl.bind(this)}>Do it</a>
                        </div>
                    </div> */}

                    <div className="card">
                        <div className="card__content">
                            <p className="card__title">
                                Take a pregnancy test
                            </p>
                            <p className="card__text">
                                You'll want to wait 1-2 weeks before taking a pregnancy test
                            </p>
                        </div>
                        <div className="card__actions">
                            <a className="card__action" onClick={this.goToPregnancyList.bind(this)}>Get a pregnancy test</a>
                        </div>
                    </div>

                </div>

            </div>
        )
    }
}

export default Over72Hours;


// WEBPACK FOOTER //
// ./src/components/screens/Over72Hours.js